//[warning] when changing OrderStatus, check to see if changes need to be applied on OrderLineStatus as well
export enum OrderStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  CHECKED_VALID = 'CHECKED_VALID',
  CREATED = 'CREATED',
  CONFIRMED = 'CONFIRMED',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED'
}

export enum OrderStatusNotUsedInFE {
  CANCELLING = 'CANCELLING',
  BACK_ORDERED = 'BACK_ORDERED',
  B2B_PROCESSING_ERROR = 'B2B_PROCESSING_ERROR',
  REJECTED = 'REJECTED',
  SHIPPED = 'SHIPPED'
}

export enum OrderLineStatus {
  PLACED = 'PLACED',
  CONFIRMED = 'CONFIRMED',
  CANCELLED = 'CANCELLED',
  BACK_ORDERED = 'BACK_ORDERED',
  CANCELLING = 'CANCELLING',
  PARTIALLY_DELIVERED = 'PARTIALLY_DELIVERED',
  DELIVERED = 'DELIVERED'
}

export enum OrderLineStatusNotUsedInFE {
  SHIPPED = 'SHIPPED',
  COMPLETED = 'COMPLETED',
  CREATED = 'CREATED'
}

export enum OrderHistory {
  PAGE_SIZE = 'pageSize',
  CURRENT_PAGE = 'currentPage',
  SORT = 'sort',
  STATUSES = 'statuses',
  CODE = 'code',
  ISLINEFILTER = 'isLineFilter'
}
